export const ProDIYBannerAndFooterCopies = {
  // before release new tier
  title: "Upgrade for more, faster, better Applets with advanced features.",
  titleForUpgradePro: "Get unlimited Applets with IFTTT Pro+",
  buttonLabel: "Upgrade",
}
